import React from "react";

export function PageHeader({ title, subtitle, actions, testid = "page-header" }) {
  return (
    <header
      data-testid={testid}
      className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8"
    >
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-ink">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-ink-muted text-base">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}

export function Card({ className = "", children, ...rest }) {
  return (
    <div
      className={`bg-white rounded-2xl border border-[var(--border-default)] shadow-[0_4px_16px_-4px_rgba(8,105,80,0.06)] ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function EmptyState({ title, subtitle, icon: Icon, testid = "empty-state" }) {
  return (
    <div
      data-testid={testid}
      className="py-16 flex flex-col items-center justify-center text-center gap-3 text-ink-muted"
    >
      {Icon && <Icon className="w-10 h-10 text-ink-faint" />}
      <div className="font-heading font-bold text-lg text-ink">{title}</div>
      {subtitle && <div className="text-sm">{subtitle}</div>}
    </div>
  );
}

export function Badge({ children, tone = "neutral", className = "" }) {
  const tones = {
    neutral: "bg-subtle text-ink",
    brand: "bg-brand/10 text-brand",
    success: "bg-[#2d8a56]/10 text-[#2d8a56]",
    warning: "bg-[#e3a03b]/15 text-[#8a5a10]",
    danger: "bg-[#d34044]/10 text-[#b12e31]",
    info: "bg-[#2563eb]/10 text-[#2563eb]",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${tones[tone] || tones.neutral} ${className}`}
    >
      {children}
    </span>
  );
}
